<template>
    <div v-if="canShow('舌象分析') && info && info.tizhi_content && info.tizhi_content.tongue">
        <div v-if="!isPrint">
            <div class="sick-box">
                <div class="risk">舌象分析</div>
            </div>
            <div class="assessment">
                <div class="table-mark">
                    <table class="newre-table">
                        <thead>
                            <tr>
                                <th>舌象指标</th>
                                <th>舌象结果</th>
                            </tr>
                        </thead>
                        <tbody v-for="(item, index) in info.tizhi_content.tongue" :key="index" >
                            <tr v-if=" item.name !== '暗短' && item.name !== '舌根'">
                                <td>{{ TongueFilter(item.name) }}</td>
                                <td>{{ formatTongueData(item) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        
        <!-- <div class="sick-tongue">
            <div class="inner-name flex">
                <div class="flex-1">舌象指标</div>
                <div class="flex-1">舌象结果</div>
            </div>
            <div v-for="(item, index) in info.tizhi_content.tongue" :key="index">
                <div class="flex" v-if=" item.name !== '舌形' && item.name !== '暗短'">
                    <div class="flex-1">{{ TongueFilter(item.name) }}</div>
                    <div class="flex-1">{{ item.data?item.data:'正常' }}</div>
                </div>
            </div>
        </div> -->

        <div v-if="info.tizhi_content.jiangjie && info.tizhi_content.jiangjie.length">
            <div class="face-analysis-title">{{ isPrint ? '舌象' : '舌象解析' }}</div>
            <div class="dotted-line"></div>
            <div class="face-analysis-item" v-for="(item, index) in info.tizhi_content.jiangjie" :key="index">
                <div class="face-imgs" v-if="index === 0 && info.tizhi_content.tongue_image_url">
                    <img :src="info.tizhi_content.tongue_image_url" alt="" @click="previewImage" />
                </div>
                <div class="face-title" :class="{ 'tongue-step-next': index > 0 }">
                    {{ tongueStepMark(index) }}【{{ TongueFilter(item.name) }}：{{ formatTongueData({ name: item.name, data: item.data }) }}】
                </div>
                <div v-if="item.Jiangjie" class="face-desc">{{ item.Jiangjie }}</div>
                <div v-if="item.Jiangkang" class="face-subtitle">【健康指征】</div>
                <div v-if="item.Jiangkang" class="face-desc">{{ item.Jiangkang }}</div>
            </div>
            <div class="dotted-line"></div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import { moduleMixin, TongueFilter } from '../helpers';
import { ImagePreview } from 'vant';

export default {
    name: 'ReportTongue',
    mixins: [moduleMixin],
    computed: {
        ...mapState('report', ['info'])
    },
    methods: {
        TongueFilter,
        tongueStepMark(i) {
            const c = '①②③④⑤⑥⑦⑧⑨⑩';
            return c[i] != null ? c[i] : `${i + 1}、`;
        },
        previewImage(e) {
            const container = e.target.parentNode;
            const imgElements = container.querySelectorAll('img');
            const images = [];
            let startPosition = 0;
            
            imgElements.forEach((img) => {
                const src = img.getAttribute('src');
                if (src) {
                    images.push(src);
                    if (img === e.target) {
                        startPosition = images.length - 1;
                    }
                }
            });

            if (images.length > 0) {
                ImagePreview({
                    images,
                    startPosition
                });
            }
        },
        // 齿痕/裂痕：data 为对应名称视为"有"，"正常"或空视为"无"
        // 其他指标：data 有值则原样展示，无值则展示"正常"
        formatTongueData(item) {
            if (!item) return '正常';
            const name = item.name;
            const data = item.data;
            if (name === '齿痕' || name === '裂痕') {
                if (data === name) return '有';
                if (!data || data === '正常') return '无';
                return data;
            }
            return data ? data : '正常';
        }
    }
};
</script>
<style lang="scss" scoped>
@import './Tongue.scss';
</style>
